var map = {
	"./csroll/pages/MassCreateCases.jsx": 1836,
	"./hisense/pages/CreateAccounts.jsx": 1459,
	"./hisense/pages/CreateProduct_Request.jsx": 104,
	"./hisense/pages/CreateWork_Orders.jsx": 4130,
	"./romerz/pages/CreateAccounts.jsx": 1011,
	"./romerz/pages/CreateProduct_Request.jsx": 5672,
	"./romerz/pages/CreateWork_Orders.jsx": 8626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8635;